/**
 * Enregistrement du service worker PWA.
 *
 * - Production uniquement (le cache SW en dev rend le hot-reload incompréhensible).
 * - Quand une nouvelle version est prête, un événement `kanea-sw-update` est émis
 *   sur window : l'UI (UpdateToast) propose alors « Actualiser » à l'utilisateur.
 */

export const SW_UPDATE_EVENT = 'kanea-sw-update';

export function register(): void {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Une version est déjà en attente (l'onglet est resté ouvert longtemps)
        if (registration.waiting && navigator.serviceWorker.controller) {
          window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration }));
        }

        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nouvelle version prête — on laisse l'utilisateur décider du rechargement.
              window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration }));
            }
          };
        };
      })
      .catch((error) => {
        console.error('[PWA] Échec enregistrement du service worker:', error);
      });
  });
}

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => undefined);
  }
}

/** Applique la mise à jour en attente puis recharge la page. */
export function applyUpdate(registration: ServiceWorkerRegistration): void {
  const waiting = registration.waiting;
  if (!waiting) {
    window.location.reload();
    return;
  }
  navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), {
    once: true,
  });
  waiting.postMessage({ type: 'SKIP_WAITING' });
}
